// extracted by mini-css-extract-plugin
export default {"SettingsEmptyPane":"SettingsEmptyPane_SettingsEmptyPane__If1KR"};